import axios from "axios";

export default class WishListApi {
  static async getWishList(activity_id:any){
    return axios.get(`/wishlist/${activity_id}`)
  }
}
